var _defs, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentaireBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4970b6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.72,67.76h-21.99c-.5,0-.91-.41-.91-.91s.41-.91.91-.91h21.99c5.11,0,9.26-4.15,9.26-9.26v-21.96c0-5.11-4.15-9.26-9.26-9.26h-39.43c-5.11,0-9.26,4.15-9.26,9.26v21.96c0,5.02,2.47,9.26,5.39,9.26h6.3c.5,0,.91.41.91.91s-.41.91-.91.91h-6.3c-3.97,0-7.21-4.97-7.21-11.07v-21.96c0-6.11,4.97-11.07,11.07-11.07h39.43c6.11,0,11.07,4.97,11.07,11.07v21.96c0,6.11-4.97,11.07-11.07,11.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.49,76.36c-.47,0-.86-.35-.9-.82-.05-.46.27-.89.73-.98,3.14-.62,5.79-3.34,7.88-8.08.2-.46.74-.66,1.2-.46.46.2.67.74.46,1.2-1.35,3.05-2.94,5.36-4.76,6.92,4.84-.71,12.43-2.65,17.45-7.91.35-.36.92-.38,1.28-.03.36.35.38.92.03,1.28-8.38,8.79-22.76,8.89-23.37,8.89Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.62,49.41c-2.04,0-3.7-1.66-3.7-3.71s1.66-3.7,3.7-3.7,3.7,1.66,3.7,3.7-1.66,3.71-3.7,3.71ZM64.62,43.81c-1.04,0-1.89.85-1.89,1.89s.85,1.89,1.89,1.89,1.89-.85,1.89-1.89-.85-1.89-1.89-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,49.41c-2.04,0-3.7-1.66-3.7-3.71s1.66-3.7,3.7-3.7,3.7,1.66,3.7,3.7-1.66,3.71-3.7,3.71ZM75,43.81c-1.04,0-1.89.85-1.89,1.89s.85,1.89,1.89,1.89,1.89-.85,1.89-1.89-.85-1.89-1.89-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.38,49.41c-2.04,0-3.7-1.66-3.7-3.71s1.66-3.7,3.7-3.7,3.7,1.66,3.7,3.7-1.66,3.71-3.7,3.71ZM85.38,43.81c-1.04,0-1.89.85-1.89,1.89s.85,1.89,1.89,1.89,1.89-.85,1.89-1.89-.85-1.89-1.89-1.89Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentaireBleu);
export default __webpack_public_path__ + "static/media/commentaire_bleu.20dea4801d04a345ab358271d681fa35.svg";
export { ForwardRef as ReactComponent };